import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(protected)/admin/(content)/emergency-broadcast": [6],
		"/admin/feedbacks/[id]": [7],
		"/alerts": [8],
		"/alerts/[id]": [9,[],[2]],
		"/approved-alerts": [10],
		"/dashboard": [11],
		"/dashboard/admin": [12],
		"/feedback": [13],
		"/field-operations/field-tech-portal": [14],
		"/field-operations/field-tech-portal/debug": [16],
		"/field-operations/field-tech-portal/[work_order_id]/dashboard": [15],
		"/login": [17],
		"/logs": [18],
		"/my-feedback": [19],
		"/my-feedback/[id]": [20],
		"/profile": [21],
		"/reset-password": [~22],
		"/technician": [23,[3]],
		"/technician/alerts": [24,[3]],
		"/technician/settings": [25,[3]],
		"/technician/shifts": [26,[3]],
		"/technician/tracking": [27,[3]],
		"/technician/work-orders": [28,[3]],
		"/technician/work-orders/[id]": [29,[3]],
		"/test-expand": [30],
		"/test-logger": [31],
		"/work-orders": [32],
		"/work-orders/[id]": [33,[],[4]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';